/**
 * PullToRefreshIndicator — visual feedback pill for pull-to-refresh.
 *
 * Place this as the first child of the scrollable container. It absolutely
 * positions at the top and reveals as the user pulls.
 */
import React from 'react';
import { RefreshCw } from 'lucide-react';

export function PullToRefreshIndicator({ distance = 0, threshold = 70, refreshing = false }) {
  const progress = Math.min(1, distance / threshold);
  const rotation = progress * 360;
  const visible = distance > 4 || refreshing;
  const ready = distance >= threshold;

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-0 right-0 top-0 flex justify-center"
      style={{
        height: Math.max(0, refreshing ? 48 : distance),
        opacity: visible ? 1 : 0,
        transition: refreshing ? 'height 0.2s ease' : 'none',
        zIndex: 5,
      }}
      data-testid="pull-to-refresh"
    >
      <div
        className={`mt-2 flex items-center gap-2 rounded-full border border-slate-200 bg-white/95 shadow-sm px-3 py-1.5 text-xs ${
          ready || refreshing ? 'text-indigo-700' : 'text-slate-500'
        }`}
      >
        <RefreshCw
          className={`w-3.5 h-3.5 ${refreshing ? 'animate-spin' : ''}`}
          style={refreshing ? {} : { transform: `rotate(${rotation}deg)`, transition: 'transform 0.05s linear' }}
        />
        <span className="font-medium">
          {refreshing ? 'Refreshing…' : ready ? 'Release to refresh' : 'Pull to refresh'}
        </span>
      </div>
    </div>
  );
}
